const FALLBACK_SYMBOL = "₹";
const FALLBACK_CODE = "INR";

// Accept camelCase or snake_case from the API
const symbolOf = (c) => c?.currencySymbol || c?.currency_symbol || "";
const codeOf = (c) => c?.currency || c?.currencyCode || "";

/**
 * Pick the country used for currency display.
 * Priority: bullion rate country -> customer country -> login country
 */
export const getDisplayCountry = ({
  bullionRates = [],
  customer = null,
  loginCountry = null,
} = {}) => {
  for (const rate of bullionRates || []) {
    const c =rate?.country || rate?.countryDetails;
    if (symbolOf(c)) return c;
  }
  if (symbolOf(customer?.countryDetails)) return customer.countryDetails;
  if (symbolOf(loginCountry)) return loginCountry;
  return null;
};

export const getCurrencySymbol = (ctx) =>
  symbolOf(getDisplayCountry(ctx)) || FALLBACK_SYMBOL;

export const getCurrencyCode = (ctx) =>
  codeOf(getDisplayCountry(ctx)) || FALLBACK_CODE;

/** Format number with symbol, e.g. formatAmount(125000, ctx) -> "₹ 1,25,000.00" */
export const formatAmount = (value, ctx, { decimals = 2 } = {}) => {
  const n = Number(value) || 0;
  const code = getCurrencyCode(ctx);
  const locale = code === "INR" ? "en-IN" : undefined; // Indian digit grouping
  const num = n.toLocaleString(locale, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
  return `${getCurrencySymbol(ctx)} ${num}`;
};